module.exports = __webpack_public_path__ + "img/valentines-day.6ed20cbc.png";